import React, {Component} from 'react';
import { debounce } from 'lodash';

export default class SearchBar extends React.Component {
    constructor(props){
        super(props);
        this.updateFilter = debounce(this.updateFilter, 500);
    }

    updateFilter(e){
        this.props.onChange(e);
    }

    render() {
        return (
            <div className="form-group">
                <input type="text"
                       defaultValue={this.props.initialSearchText}
                       className="form-control"
                       placeholder="Søg..."
                       onChange={e => this.updateFilter(e.target.value) }
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web/src/components/common/searchbar/SearchBar.jsx